import React, { Component, Fragment } from "react";
import { injectIntl } from "react-intl";

import API from "../../api/index";
import { Row, Card, Button, Input, Form, FormGroup, CardTitle, Label, Collapse, CardBody, Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import { logoutUser } from "Redux/actions";
import { connect } from "react-redux";
import moment from "jalali-moment";
import { Colxx } from "Components/CustomBootstrap";
import "react-circular-progressbar/dist/styles.css";
import "react-tabs/style/react-tabs.css";
import StateButton from "Components/StateButton";
import NumberFormat from "react-number-format";
import Select from "react-select";
import CustomSelectInput from "Components/CustomSelectInput";

import { RangeDatePicker } from "jalali-react-datepicker";
import { NotificationManager } from "Components/ReactNotifications";
import { journalReportFilters } from './monthly-report-model';
import { validJournalInteger } from '../../util/journal-input';

class WarehousingJournal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			showDetails: false,
			isRefreshing: false,
			modalCreateTransactionOpen: false,
			collapseFilterOpen: false,
			tab: "ALL",

			search: {
				transactionCount: "",
				transactionCountOperator: "=",
				transactionDescription: "",
				transactionType: "ALL",
				transactionIsCheckPoint:"ALL",
				transactionCreatedAt: "",
				transactionDate: "",
				transactionProductId: -1,
				sortColumn: "created",
				sortDirection: "ZA",
				currentPage: 1,
			},
			APISearchData: {},
			searchReset: null,

			newTransaction: {
				count: "",
				type: "OUTFLOW",
				description: "",
				productId: -1,
			},
			newTransactionReset: null,
			newTransactionButtonClicked: false,
			transactions: [],
			paging: [],
			summary: false,
			isLoading: true,
			showSearchSummary: false,
			SearchSummaryData: null,
			products: [],
		};
		this.modalCreateTransactionToggle = this.modalCreateTransactionToggle.bind(this);
		this.collapseFilterToggle = this.collapseFilterToggle.bind(this);
		this.validateSearchFilter = this.validateSearchFilter.bind(this);
		this.validatenewTransactionFilter = this.validatenewTransactionFilter.bind(this);
		this.setTransactionCreatedDateRange = this.setTransactionCreatedDateRange.bind(this);
		this.componentDidMount = this.componentDidMount.bind(this);
		this.handleTransactionCreateReset = this.handleTransactionCreateReset.bind(this);
		this.handleSearchReset = this.handleSearchReset.bind(this);
		this.validateTransactionCreation = this.validateTransactionCreation.bind(this);
		this.handleCreateTransactionButtonClick = this.handleCreateTransactionButtonClick.bind(this);
		this.handleSortClick = this.handleSortClick.bind(this);
		this.loadData = this.loadData.bind(this);
		this.doSearch = this.doSearch.bind(this);
		this.generateProductSelectData = this.generateProductSelectData.bind(this);
		this.handleProductSelection = this.handleProductSelection.bind(this);
		this.handleNewTransactionProductSelection = this.handleNewTransactionProductSelection.bind(this);
		this.findSelectedProductLabel = this.findSelectedProductLabel.bind(this);
	}
	handleProductSelection(selectedOption) {
		const updatedSearch = { ...this.state.search, transactionProductId: selectedOption.value };
		this.setState({
			selectedOption,
			search: updatedSearch,
		});
	}
	handleNewTransactionProductSelection(selectedOption) {
		const updatedNewTransaction = { ...this.state.newTransaction, productId: selectedOption.value };
		this.setState({
			selectedOption,
			newTransaction: updatedNewTransaction,
		});
	}
	findSelectedProductLabel(productId) {
		const selectedProduct = this.state.products.find((product) => String(product.id) === String(productId));
		return selectedProduct ? selectedProduct.name : "انتخاب کنید...";
	}

	generateProductSelectData() {
		const selectData = this.state.products.map((product, index) => ({
			label: `${product.name}`,
			value: product.id,
			key: index,
		}));
		return [{ label: "انتخاب کنید...", value: -1 }, ...selectData];
	}
	handleFocus = (event) => event.target.select();
	handleSortClick(column) {
		this.setState(
			(prevState) => {
				const newSearch = { ...prevState.search };
				if (newSearch.sortColumn !== column) {
					newSearch.sortColumn = column;
					newSearch.sortDirection = "AZ";
				} else {
					newSearch.sortDirection = newSearch.sortDirection === "AZ" ? "ZA" : "AZ";
				}
				return { search: newSearch };
			},
			() => {
				this.doSearch();
			}
		);
	}

	handleTransactionCreateReset() {
		// reset newTransaction to the initial state
		const newTransactionResetTemp = this.state.newTransactionReset;
		this.setState({ newTransaction: { ...newTransactionResetTemp } });
	}

	handleSearchReset() {
		if (journalReportFilters(this.props.location.search)) {
			this.props.history.replace({ pathname: this.props.location.pathname, search: '' });
			return;
		}
		// reset newTransaction to the initial state
		const newSearchResetTemp = this.state.searchReset;
		this.setState({ search: { ...newSearchResetTemp }, showSearchSummary: false, SearchSummaryData: null, APISearchData: { ...this.state.searchReset } }, () => {
			this.loadData();
		});
	}

	setTransactionCreatedDateRange(range, param) {
		var tmpObj = this.state.search;
		tmpObj.transactionCreatedAt = range;
		this.setState({ search: tmpObj });
	}

	validatenewTransactionFilter(filter, value) {
		if (value === undefined) {
			return false;
		}
		switch (filter) {
			case "transaction-count":
				if (validJournalInteger(value)) {
					return true;
				}
				break;
			case "transaction-productid": {
				if (value > 0) {
					return true;
				}
				break;
			}
			case "transaction-description":
				if (value.length > 2) {
					return true;
				}
				break;
		}
		return false;
	}
	validateTransactionCreation() {
		const filters = {
			"transaction-count": this.state.newTransaction.count,
			"transaction-description": this.state.newTransaction.description,
		};

		for (const [key, value] of Object.entries(filters)) {
			if (!this.validatenewTransactionFilter(key, value)) {
				return false;
			}
		}

		return true;
	}
	validateSearchFilter(filter, value) {
		switch (filter) {
			case "transaction-count":
				if (value > 0) {
					return true;
				}
				break;
			case "transaction-description":
				if (value.length > 0) {
					return true;
				}
				break;
		}
		return false;
	}
	collapseFilterToggle() {
		this.setState({
			collapseFilterOpen: !this.state.collapseFilterOpen,
		});
	}
	modalCreateTransactionToggle() {
		this.setState({
			modalCreateTransactionOpen: !this.state.modalCreateTransactionOpen,
		});
	}
	componentDidMount() {
		const newTransactionReset = { ...this.state.newTransaction };
		const searchReset = { ...this.state.search };
		const preset = journalReportFilters(this.props.location.search);
		const apiSerachData = { ...this.state.search, ...(preset || {}) };
		this.setState(
			{
				newTransactionReset: { ...newTransactionReset },
				searchReset: { ...searchReset },
				APISearchData: { ...apiSerachData },
				search: { ...apiSerachData },
				showSearchSummary: !!preset,
				SearchSummaryData: preset ? { ...apiSerachData } : null,
				collapseFilterOpen: !!preset,
			},
			() => {
				this.loadData();
			}
		);
	}
	componentDidUpdate(previousProps) {
		if (previousProps.location.search === this.props.location.search) return;
		const preset = journalReportFilters(this.props.location.search);
		if (!preset) {
			if (journalReportFilters(previousProps.location.search)) this.handleSearchReset();
			return;
		}
		const search = { ...this.state.searchReset, ...preset };
		this.setState({ search, APISearchData: { ...search }, SearchSummaryData: { ...search },
			showSearchSummary: true, collapseFilterOpen: true }, this.loadData);
	}

	handleCreateTransactionButtonClick() {
		return new Promise((success, fail, $this) => {
			this.setState({ newTransactionButtonClicked: true });
			API.post("warehousing/transaction/add", this.state.newTransaction)
				.then((data) => {
					data.RELOGIN ? this.props.logoutUser(this.props.history) : 0;

					if (data.ERRORS !== undefined) {
						fail("خطا در ثبت تراکنش");
						for (var i = 0; i < data.ERRORS.length; i++) {
							setTimeout(
								function (err) {
									NotificationManager.error(err, "خطا در ثبت تراکنش", 8000, null, null, "filled");
								},
								(i + 1) * 700,
								data.ERRORS[i]
							);
						}
						this.setState({
							newTransactionButtonClicked: false,
						});
					} else {
						success("تراکنش ثبت شد");
						setTimeout(() => {
							this.setState({ newTransactionButtonClicked: false, modalCreateTransactionOpen: false });
							this.handleTransactionCreateReset();
							this.loadData();
						}, 1000);
					}
				})
				.catch((error) => {
					fail("خطا در ثبت تراکنش");
					this.setState({
						newTransactionButtonClicked: false,
					});
				});
		});
	}
	doSearch() {
		const tmpObj = JSON.parse(JSON.stringify(this.state.search));
		tmpObj.currentPage = 1;

		let SearchSummaryData = { ...tmpObj }; // Create a separate object for cachedSearchData

		this.setState(
			{
				APISearchData: tmpObj,
				showSearchSummary: true,
				SearchSummaryData,
				isRefreshing: true,
			},
			() => {
				this.loadData();
			}
		);
	}

	loadData() {
		this.setState({ isRefreshing: true });
		API.post("warehousing/transactions/list", this.state.APISearchData)
			.then((data) => {
				data.RELOGIN ? this.props.logoutUser(this.props.history) : 0;

				this.setState(
					{
						transactions: data.transactions,
						products: data.products,
						paging: data.paging,
						summary: data.summary,
						settings: data.settings,
						isLoading: false,
						isRefreshing: false,
					},
					function () {}
				);
			})
			.catch((error) => {});
	}
	render() {
		return this.state.isLoading ? (
			<div className="loading"></div>
		) : (
			<Fragment>
				<Row className={"invoice"}>
					<Colxx xl="12">
						<Card>
							<CardBody>
								<CardTitle className={"print-hide"}>
									<div
										className={"iconsminds-calendar-4 headingicon"}
										onClick={() => {
											this.setState({ showDetails: !this.state.showDetails });
										}}
										style={{ color: this.state.showDetails ? "#4fcdc4" : "#556270" }}
									/>
									دفتر انبارداری
									<Button
										color="primary"
										outline
										style={{ float: "left" }}
										className={"default"}
										onClick={() => {
											this.setState({ modalCreateTransactionOpen: true });
										}}
									>
										<i className="iconsminds-add icon-size-20" style={{ fontWeigh: "bold" }}></i>&nbsp; تراکنش جدید
									</Button>
									<Modal size="lg" isOpen={this.state.modalCreateTransactionOpen} toggle={this.modalCreateTransactionToggle}>
										<ModalHeader toggle={this.modalCreateTransactionToggle}>ثبت تراکنش انبار </ModalHeader>
										<ModalBody>
											<Row>
												<Colxx sm={4}>
													<FormGroup className={"filter " + (this.validatenewTransactionFilter("transaction-count", this.state.newTransaction.count) ? "filter-active" : "")}>
														<Label for="newTransactionCount" style={{ width: "100%" }}>
															تعداد *
														</Label>
														<NumberFormat
															value={this.state.newTransaction.count}
															onClick={this.handleFocus}
															onValueChange={(values) => {
																var tmpObj = { ...this.state.newTransaction };
																tmpObj.count = values.value;
																this.setState({ newTransaction: tmpObj });
															}}
															style={{ width: "60%", height: "40px", border: "1px solid #d7d7d7", display: "inline-block", float: "right" }}
															thousandSeparator={true}
														/>
														<span
															style={{
																border: "1px solid ",
																borderColor: this.state.newTransaction.type == "OUTFLOW" ? "#ffd3d3" : "#d3ffd5",
																borderRadius: "5px",
																background: this.state.newTransaction.type == "OUTFLOW" ? "#ffd3d3" : "#d3ffd5",
																cursor: "pointer",
																marginRight: 10,
																display: "inline-block",
																width: "30%",
																height: "40px",
																lineHeight: "30px",
																textAlign: "center",
																paddingTop: "5px",
																paddingLeft: "10px",
																paddingRight: "10px",
																textAlign: "center",
																flaot: "left",
																color: this.state.newTransaction.type == "OUTFLOW" ? "red" : "green",
															}}
															onClick={(e) => {
																var tmpObj = { ...this.state.newTransaction };
																tmpObj.type = this.state.newTransaction.type == "OUTFLOW" ? "INFLOW" : "OUTFLOW";
																this.setState({ newTransaction: tmpObj });
															}}
														>
															{this.state.newTransaction.type == "OUTFLOW" ? "خروج" : "ورود"}
														</span>
													</FormGroup>
												</Colxx>

												<Colxx sm={4}>
													<FormGroup className={"filter " + (this.validatenewTransactionFilter("transaction-productid", this.state.newTransaction.productId) ? "filter-active" : "")}>
														<Label for="newTransactionCode">کالا *</Label>

														<Select
															components={{ Input: CustomSelectInput }}
															className="react-select"
															classNamePrefix="react-select"
															name="new-transaction-product-select"
															value={
																this.state.newTransaction.productId !== -1
																	? { value: this.state.newTransaction.productId, label: this.findSelectedProductLabel(this.state.newTransaction.productId) }
																	: { value: -1, label: "انتخاب کنید..." }
															}
															onChange={this.handleNewTransactionProductSelection}
															options={this.generateProductSelectData()} // Call the function to generate options
															placeholder="انتخاب کنید..."
														/>
													</FormGroup>
												</Colxx>
											</Row>

											<Row>
												<Colxx sm={12}>
													<FormGroup className={"filter " + (this.validatenewTransactionFilter("transaction-description", this.state.newTransaction.description) ? "filter-active" : "")}>
														<Label for="newTransactionDescription">توضیحات *</Label>

														<Input
															type="text"
															name="newTransactionDescription"
															id="newTransactionDescription"
															onClick={this.handleFocus}
															placeholder="لیوان شکست ... / خرید لیوان از لیوان برند فلان ..."
															value={this.state.newTransaction.description}
															onChange={(e) => {
																var tmpObj = { ...this.state.newTransaction };
																tmpObj.description = e.target.value;
																this.setState({ newTransaction: tmpObj });
															}}
														/>
													</FormGroup>
												</Colxx>
											</Row>
										</ModalBody>
										<ModalFooter>
											<Button
												color="light"
												style={{
													float: "left",
													marginLeft: "10px",
													marginTop: "-14px",
												}}
												className={"default"}
												onClick={this.handleTransactionCreateReset}
											>
												ریست
											</Button>
											<StateButton disabled={!this.validateTransactionCreation()} id="newBatchSaveButton" color="primary" className="mb-3 default" onClick={() => this.handleCreateTransactionButtonClick()}>
												ثبت
											</StateButton>
										</ModalFooter>
									</Modal>
								</CardTitle>
								<Fragment>
									<div className="border productPanel print-hide">
										<Button block color="link" className="text-right" onClick={() => this.collapseFilterToggle()} aria-expanded={this.state.collapseFilterOpen}>
											<i className="glyph-icon simple-icon-magnifier" style={{ marginLeft: "5px", fontSize: "14px" }}></i>
											فرم جستجو
											<i className="glyph-icon simple-icon-arrow-down" style={{ marginRight: "10px", fontSize: "10px" }}></i>
										</Button>

										<div
											className="dropdown-buttons"
											style={{
												float: "left",
												display: this.state.collapseFilterOpen ? "inline-block" : "none",
											}}
										>
											<Button
												color="primary"
												className={"default"}
												style={{
													float: "left",
													marginLeft: "10px",
												}}
												onClick={this.doSearch}
											>
												جستجو کن
											</Button>
											<Button
												color="light"
												style={{
													float: "left",
													marginLeft: "10px",
												}}
												className={"default"}
												onClick={this.handleSearchReset}
											>
												ریست
											</Button>
										</div>
										<Collapse isOpen={this.state.collapseFilterOpen} style={{ marginTop: "0px" }}>
											<div className="" style={{ padding: "20px", paddingBottom: 0 }}>
												<Row className="mb-4">
													<Colxx xxs="12">
														<Form>
															<FormGroup row>
																<Colxx sm={3}>
																	<FormGroup className={"filter " + (this.validateSearchFilter("transaction-count", this.state.search.transactionCount) ? "filter-active" : "")}>
																		<Label for="transactionCount">تعداد کالا</Label>
																		<span
																			style={{
																				border: "1px solid lightgray",
																				borderRadius: "5px",
																				background: "#eaeaea",
																				cursor: "pointer",
																				marginRight: 10,
																				display: "inline-block",
																				width: "25px",
																				textAlign: "center",
																				paddingTop: "5px",
																			}}
																			onClick={(e) => {
																				const operators = ["=", ">", "<", ">=", "=<"];
																				var tmpObj = { ...this.state.search };
																				tmpObj.transactionCountOperator = operators[(operators.indexOf(this.state.search.transactionCountOperator) + 1) % operators.length];
																				this.setState({ search: tmpObj });
																			}}
																		>
																			{this.state.search.transactionCountOperator}
																		</span>{" "}
																		<span style={{ color: "lightgray" }}>{this.state.search.transactionCountOperator == "=" ? "با" : "از"} مقدار وروردی</span>
																		<NumberFormat
																			type="text"
																			name="transactionCount"
																			id="transactionCount"
																			value={this.state.search.transactionCount}
																			onClick={this.handleFocus}
																			onValueChange={(values) => {
																				var tmpObj = { ...this.state.search };
																				tmpObj.transactionCount = values.value;
																				this.setState({ search: tmpObj });
																			}}
																			style={{ width: "100%", height: "40px", border: "1px solid #d7d7d7" }}
																			thousandSeparator={true}
																		/>
																	</FormGroup>
																	<FormGroup className={"filter " + (this.state.search.transactionType != "ALL" ? "filter-active" : "")}>
																		<Label>نوع تراکنش</Label>
																		<Input
																			type="select"
																			onChange={(e) => {
																				var tmpObj = { ...this.state.search };
																				tmpObj.transactionType = e.target.value;
																				this.setState({ search: tmpObj });
																			}}
																			value={this.state.search.transactionType}
																		>
																			<option value="ALL">همه نوع</option>
																			<option value="INFLOW">ورود</option>
																			<option value="OUTFLOW">خروج</option>
																		</Input>
																	</FormGroup>
																</Colxx>
																<Colxx sm={3}>
																	<FormGroup className={"filter "}>
																		<Label for="productSelection">کالا</Label>
																		<Select
																			components={{ Input: CustomSelectInput }}
																			className="react-select"
																			classNamePrefix="react-select"
																			name="product-select"
																			value={
																				this.state.search.transactionProductId !== -1
																					? { value: this.state.search.transactionProductId, label: this.findSelectedProductLabel(this.state.search.transactionProductId) }
																					: { value: -1, label: "انتخاب کنید..." }
																			}
																			onChange={this.handleProductSelection}
																			options={this.generateProductSelectData()} // Call the function to generate options
																			placeholder="انتخاب کنید..."
																		/>
																	</FormGroup>
																	<FormGroup style={{ marginBottom: 0 }} className={"filter " + (this.validateSearchFilter("transaction-description", this.state.search.transactionDescription) ? "filter-active" : "")}>
																		<Label for="transactionDescription">توضیحات تراکنش (شامل)</Label>

																		<Input
																			type="text"
																			name="transactionDescription"
																			id="transactionDescription"
																			onClick={this.handleFocus}
																			placeholder=""
																			value={this.state.search.transactionDescription}
																			onChange={(e) => {
																				var tmpObj = { ...this.state.search };
																				tmpObj.transactionDescription = e.target.value;
																				this.setState({ search: tmpObj });
																			}}
																		/>
																	</FormGroup>
																</Colxx>
																<Colxx sm={2}>
																	<FormGroup className={"filter " + (this.state.search.transactionCreatedAt != "" ? "filter-active" : "")}>
																		<Button
																			style={{
																				float: "left",
																				padding: "5px",
																				color: "black",
																				backgroundColor: "transparent",
																				border: "unset",
																				display: this.state.search.transactionCreatedAt != "" ? "block" : "none",
																			}}
																			onClick={(e) => {
																				var tmpObj = { ...this.state.search };
																				tmpObj.transactionCreatedAt = "";
																				this.setState({ search: tmpObj });
																			}}
																		>
																			<i className="simple-icon-close"></i>
																		</Button>
																		<div className="datepicker">
																			<RangeDatePicker key={JSON.stringify(this.state.search.transactionCreatedAt || '')}
																				start={this.state.search.transactionCreatedAt?.start ? moment(this.state.search.transactionCreatedAt.start).locale('fa').format('YYYY/MM/DD') : undefined}
																				end={this.state.search.transactionCreatedAt?.end ? moment(this.state.search.transactionCreatedAt.end).locale('fa').format('YYYY/MM/DD') : undefined}
																				fromLabel="ثبت شده از تاریخ" toLabel="ثبت شده تا تاریخ" onClickSubmitButton={this.setTransactionCreatedDateRange} />
																		</div>
																	</FormGroup>
																</Colxx>
																<Colxx sm={2}>
																<FormGroup className={"filter " + (this.state.search.transactionIsCheckPoint != "ALL" ? "filter-active" : "")}>
																		<Label>انبارگردانی</Label>
																		<Input
																			type="select"
																			onChange={(e) => {
																				var tmpObj = { ...this.state.search };
																				tmpObj.transactionIsCheckPoint = e.target.value;
																				this.setState({ search: tmpObj });
																			}}
																			value={this.state.search.transactionIsCheckPoint}
																		>
																			<option value="ALL">همه</option>
																			<option value="IGNORE_CHECKPOINTS">بدون تراکنش‌های انبارگردانی</option>
																			<option value="ONLY_CHECKPOINTS">فقط تراکنش‌های انبارگردانی</option>
																		</Input>
																	</FormGroup>
																</Colxx>
															</FormGroup>
														</Form>
													</Colxx>
												</Row>
											</div>
										</Collapse>
									</div>
									<br />
								</Fragment>
								<Fragment>
									{this.state.showSearchSummary && (
										<table className="search-summary-table">
											<tbody>
												<tr>
													<th>مبلغ تراکنش</th>
													<td>
														{this.state.SearchSummaryData.transactionCount ? (
															<NumberFormat
																value={this.state.SearchSummaryData.transactionCount}
																displayType={"text"}
																thousandSeparator={true}
																suffix=" تومان "
																prefix={` ${this.state.SearchSummaryData.transactionCountOperator || ""} `}
																renderText={(value) => <span>{value}</span>}
															/>
														) : (
															"-"
														)}
													</td>
													<th>نوع تراکنش</th>
													<td>
														{{
															ALL: "همه نوع",
															INFLOW: "واریز",
															OUTFLOW: "برداشت",
														}[this.state.SearchSummaryData.transactionType] || "-"}
													</td>
												</tr>
												<tr>
													<th>توضیحات تراکنش</th>
													<td>{this.state.SearchSummaryData.transactionDescription || "-"}</td>
												</tr>

												<tr>
													<th>ثبت شده از تاریخ</th>
													<td>{this.state.SearchSummaryData.transactionCreatedAt?.start ? moment(this.state.SearchSummaryData.transactionCreatedAt.start).locale("fa").format("YYYY/MM/DD") : "-"}</td>
													<th>ثبت شده تا تاریخ</th>
													<td>{this.state.SearchSummaryData.transactionCreatedAt?.end ? moment(this.state.SearchSummaryData.transactionCreatedAt.end).locale("fa").format("YYYY/MM/DD") : "-"}</td>
												</tr>
											</tbody>
										</table>
									)}
								</Fragment>
								<div className="table-responsive print-show">
									<table className={"table table-hover order-table print-table" + (this.state.showDetails ? " show-details" : "")}>
										<thead>
											<tr>
												<th style={{ width: "50px", display: "none" }} className={"print-show-cell"}>
													ردیف
												</th>
												{this.state.showDetails && <th style={{ width: "100px" }}>اپراتور</th>}
												{this.state.showDetails && <th style={{ width: "100px" }}>کد</th>}
												{this.state.showDetails && <th style={{ width: "100px" }}>انبارگردانی</th>}

												<th style={{ width: "200px", cursor: "pointer" }} onClick={() => this.handleSortClick("created")}>
													تاریخ ثبت
													{this.state.search.sortColumn === "created" && (
														<i style={{ marginRight: "5px", fontWeight: "bold" }} className={`${this.state.search.sortDirection === "AZ" ? "iconsminds-triangle-arrow-up" : "iconsminds-triangle-arrow-down"}`}></i>
													)}
												</th>
												{this.state.showDetails && <th style={{ width: "100px" }}>نوع</th>}
												<th style={{ width: "250px" }}>محصول</th>
												<th style={{ width: "100px" }}>تعداد</th>
												<th style={{ textAlign: "right" }}>توضیحات</th>
											</tr>
										</thead>
										{!this.state.isRefreshing ? (
											<Fragment>
												{this.state.transactions.map((row, index) => (
													<TabAllTableRows key={row.id} index={index} data={row} showDetails={this.state.showDetails} />
												))}
											</Fragment>
										) : (
											<tbody>
												<tr>
													<td colSpan={8} style={{ padding: "20px" }}>
														<div className="loading" style={{ left: "unset", top: "unset", position: "relative", display: "block", marginLeft: "auto", marginRight: "auto" }}></div>
													</td>
												</tr>
											</tbody>
										)}
									</table>
									{this.state.summary != false && (
										<Fragment>
											<div className="summary-grid">
												<div className="grid-item">
													<div className="grid-header">بالانس</div>
													<div className="grid-content">
														<NumberFormat
															style={{ textAlign: "center" }}
															value={this.state.summary.INFLOW - this.state.summary.OUTFLOW}
															prefix="عدد "
															suffix={this.state.summary.INFLOW - this.state.summary.OUTFLOW >= 0 ? "+" : "-"}
															displayType={"text"}
															thousandSeparator={true}
															renderText={(value, prop) => <div>{value}</div>}
														/>
													</div>
												</div>
												<div className="grid-item">
													<div className="grid-header">مجموع خروجی</div>
													<div className="grid-content">
														<NumberFormat
															style={{ textAlign: "center" }}
															value={this.state.summary.OUTFLOW}
															prefix="عدد "
															suffix={this.state.summary.OUTFLOW > 0 ? "-" : ""}
															displayType={"text"}
															thousandSeparator={true}
															renderText={(value, prop) => <div>{value}</div>}
														/>
													</div>
												</div>
												<div className="grid-item">
													<div className="grid-header">مجموع ورودی</div>
													<div className="grid-content">
														<NumberFormat
															style={{ textAlign: "center" }}
															value={this.state.summary.INFLOW}
															prefix="عدد "
															suffix={this.state.summary.INFLOW > 0 ? "+" : ""}
															displayType={"text"}
															thousandSeparator={true}
															renderText={(value, prop) => <div>{value}</div>}
														/>
													</div>
												</div>
											</div>
										</Fragment>
									)}
								</div>
							</CardBody>
						</Card>
					</Colxx>
				</Row>
			</Fragment>
		);
	}
}

class TabAllTableRows extends Component {
	render() {
		const {
			data: { id, type, createdAt, count, description, operatorName, product, isCheckPoint, stockLevel },
			showDetails,
			index,
		} = this.props;

		const created = moment(createdAt).locale("fa").format("DD / MMMM / YYYY - HH:mm");
		const typeMappings = {
			INFLOW: "ورود",
			OUTFLOW: "خروج",
		};
		return (
			<tbody>
				<tr className={"order-spacer"}></tr>

				<tr className={"order-item"}>
					<td className={"text-muted print-show-cell"} style={{ display: "none" }}>
						{index + 1}
					</td>
					{showDetails && <td className={"text-muted"}>{operatorName}</td>}
					{showDetails && (
						<td className={"text-muted"}>
							<a href={`https://hub.akschap.com/node/${id}`} target="_blank">
								#{id}
							</a>
						</td>
					)}
					{showDetails && (
						<td className={"text-muted"}>
							{isCheckPoint && (
								<>
									<i className="simple-icon-check" style={{ color: "rgb(152, 171, 180)" }}></i> {stockLevel}
								</>
							)}
						</td>
					)}

					<td className={"text-muted"}>{created}</td>
					{showDetails && <td className={"text-muted"}>{typeMappings[type]}</td>}
					<td className={"text-muted"}>{product.name}</td>
					<td style={{ color: type == "INFLOW" ? "green" : "red" }}>
						<NumberFormat style={{ textAlign: "center" }} value={count} suffix={type == "INFLOW" ? "+" : "-"} displayType={"text"} thousandSeparator={true} renderText={(value, prop) => <div>{value}</div>} />
					</td>

					<td
						style={{ textAlign: "right" }}
						dangerouslySetInnerHTML={{
							__html: description,
						}}
						className="transaction-description"
					></td>
				</tr>
			</tbody>
		);
	}
}

const mapStateToProps = ({ menu, settings }) => {
	return {};
};

const mapDispatchToProps = { logoutUser };

export default injectIntl(connect(mapStateToProps, { logoutUser })(WarehousingJournal));
